/**
 * KİLİT BANDI — yalnızca ANORMALLİK varsa görünür (CLAUDE.md §6: ekranda
 * görünen her işaret bir anormallik):
 *
 *  - şifreli kaba son yazım başarısız (değişiklik cihaza YAZILMADI),
 *  - açılışta son yazım yarım kalmış, bir önceki hâl açıldı,
 *  - kurtarma ifadesi doğrulanmamış (parola unutulursa defter açılamaz).
 */

import { M } from "../../dil";
import { useEffect, useState } from "react";
import type { KilitDurumu } from "@parafon/contracts/local-api";
import { routeHref } from "../../lib/router";
import { useRepositoryContext } from "../../repo/RepositoryContext";
import { IFADE_DOGRULANDI_AYARI } from "./KurulumEkrani";

/** Yazım değişiklikten ~300 ms sonra; bant hatayı bir süre sonra da görsün diye ara okuma. */
const YOKLAMA_MS = 10_000;

export function KilitBandi() {
  const { repo, revision } = useRepositoryContext();
  const kilit = repo.kilit;
  const [durum, setDurum] = useState<KilitDurumu | null>(null);
  const [dogrulandi, setDogrulandi] = useState<boolean | null>(null);

  useEffect(() => {
    if (kilit === undefined) return;
    let iptal = false;
    const oku = (): void => {
      void kilit.durum().then(
        (d) => {
          if (!iptal) setDurum(d);
        },
        () => undefined,
      );
      void repo.settings.get(IFADE_DOGRULANDI_AYARI).then(
        (v) => {
          if (!iptal) setDogrulandi(v === "1");
        },
        () => undefined,
      );
    };
    oku();
    const gec = setTimeout(oku, 1_000);
    const ara = setInterval(oku, YOKLAMA_MS);
    return () => {
      iptal = true;
      clearTimeout(gec);
      clearInterval(ara);
    };
  }, [repo, kilit, revision]);

  if (kilit === undefined || durum === null) return null;

  if (durum.sonYazimHatasi !== null) {
    return (
      <div role="alert" className="border-b border-danger-border bg-danger-soft px-4 py-1.5 text-[12px] text-danger">
        {M.kilit.bant.yazilamadi(durum.sonYazimHatasi)}
      </div>
    );
  }
  if (durum.acilisKaynagi === "onceki") {
    return (
      <div role="status" className="border-b border-warn-border bg-warn-soft px-4 py-1.5 text-[12px] text-warn">
        {M.kilit.bant.oncekiHal}
      </div>
    );
  }
  if (dogrulandi === false) {
    return (
      <div role="status" className="border-b border-warn-border bg-warn-soft px-4 py-1.5 text-[12px] text-warn">
        {M.kilit.bant.dogrulanmadi}{" "}
        <a className="underline" href={routeHref("ayarlar")}>
          {M.kilit.bant.yeniIfadeAlin}
        </a>
      </div>
    );
  }
  return null;
}
